module.exports = __webpack_public_path__ + "media/images/flags/32/Georgia-b1b1a90cd630aa5ff9b62f1ad784bda8.png";